import {Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, ViewChildren, QueryList,  OnDestroy, NgZone, Output, EventEmitter,} from '@angular/core';
import { ReportService } from '../inservice/report.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
	text="test";
  constructor(public reportService: ReportService) { }

  ngOnInit(): void {
  }

}
